module.exports = __webpack_public_path__ + "ebf607876482549b90fa7a3c369027e1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/missing_image.png
// module id = 1549
// module chunks = 132